import { isNullable } from '@app/utils'

import type { LabelValueRowData } from '@app/components/LabelValueTable/types'

interface GenerateTableItemsArgs<DataType> {
  data?: DataType
  targetKeys: Array<keyof DataType>
  titlesMap: Partial<Record<keyof DataType, string>>
}

const hasLabel =
  <DataType>(titlesMap: Partial<Record<keyof DataType, string>>) =>
    (key: keyof DataType): boolean => {
      return !isNullable(titlesMap[key])
    }

export const generateTableItems = <DataType extends Record<keyof DataType, string | number | null>>({
  data,
  targetKeys,
  titlesMap
}: GenerateTableItemsArgs<DataType>): LabelValueRowData[] => {
  return targetKeys.filter(hasLabel(titlesMap)).map(key => {
    const label = titlesMap[key] as string
    const value = data?.[key]

    return {
      label,
      value
    }
  })
}
